import React from 'react';
import styled from 'styled-components';
import { animated } from 'react-spring';
import { Link } from 'gatsby';
// import Img from 'gatsby-image';

import DummyImage from './DummyImage';
import { Para } from './elements';

const Container = styled(animated.div)`
  .card {
    border-radius: 20px;
    border: none;
    box-shadow: 0 0 8px 0 #eee;
  }

  .title {
    font-size: ${(props) => props.theme.fontSizeNormal};
    margin-top: 1.5rem;
    line-height: 1.5rem;
  }
  .content-wrapper {
    padding: 0 1rem 0.5rem;
  }
  .is-flex {
    justify-content: space-between;
    padding: 5px 0;
  }
  .bottom {
    margin-top: 1.25rem;
  }
`;

const Image = styled.img`
  object-fit: cover;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  height: 320px;
  width: 100%;
`;

const Line = styled.div`
  height: 1px;
  background-color: #dedede;
`;

const RecipeItem = ({ item, styles }) => {
  return (
    <Container
      className="column is-one-third is-flex"
      style={styles}
      key={item.id}
    >
      <div className="card">
        <Link to="/">
          <Image src={item.image} />
        </Link>
        <div className="content-wrapper">
          <h3 className="has-text-centered title">{item.title}</h3>
          <Para normal>{item.description}</Para>
          <div className="bottom">
            <Line />
            <div className="is-flex is-uppercase">
              <Para normal secondaryFont>
                prep time
              </Para>
              <Para normal dark secondaryFont>
                5 min
              </Para>
            </div>
            <Line />
            <div className="is-flex is-uppercase">
              <Para normal secondaryFont>
                cook time
              </Para>
              <Para normal dark secondaryFont>
                5 min
              </Para>
            </div>
            <Line />
            <div className="is-flex is-uppercase">
              <Para normal secondaryFont>
                servings
              </Para>
              <Para normal dark secondaryFont>
                4 person
              </Para>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default RecipeItem;
